import AllergyCard from "./AllergyCard";

export default AllergyCard;